import { graphqlRequest } from "./client";
import type { StepState } from "./types";

export interface StepStatus {
  step: number;
  key: string;
  name: string;
  desc: string;
  state: StepState;
  completedAt?: string | null;
}

export interface PathwayOverview {
  gig: StepStatus[];
  finance: StepStatus[];
  doneCount: number;
  totalCount: number;
  percent: number;
  workEnabled: boolean;
  pathwayComplete: boolean;
}

const STEP_FIELDS = "step key name desc state completedAt";

/** Every gig and finance step with its server-decided state, for the hub. */
export async function fetchPathway(): Promise<PathwayOverview> {
  return (
    await graphqlRequest<{ getPathway: PathwayOverview }>(
      `{ getPathway { gig { ${STEP_FIELDS} } finance { ${STEP_FIELDS} } doneCount totalCount percent workEnabled pathwayComplete } }`,
    )
  ).getPathway;
}
